import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Lieferung',
    pickup: 'Abholung',
  },
  asap: 'ASAP',
  unavailable: 'Nicht verfügbar',
  ready_in_time: 'Bereit in {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Lieferung nach {{address}}',
    [ORDER_METHODS.PICKUP]: 'Abholung an {{address}}',
  },
  buttons: {
    change: 'Ändern',
    see_hours: 'Öffnungszeiten',
    change_location: 'Standort ändern',
    change_time: 'Zeit ändern',
  },
};
